export const LOCATION_PLACE = {
  USER: 'user',
  OFFICE: 'office',
  WAREHOUSE: 'nudos',
  OTHER: 'other',
  WARRANTY: 'warranty',
  DIAGNOSTIC: 'diagnostic',
  STORE: 'store',
  OWN_LOCATION: 'ownLocation',
  START: 'start',
};
export type TLocationPlace = typeof LOCATION_PLACE[keyof typeof LOCATION_PLACE];

export const ACQUISITION_TYPE = {
  SALE: 'sale',
  SUBSCRIPTION: 'subscription',
  PRODUCT_EXTERNAL: 'productExternal',
  STOCK_PRODUCT: 'stockProduct',
} as const;
export type TAcquisitionType = typeof ACQUISITION_TYPE[keyof typeof ACQUISITION_TYPE];

export type TValidationSerialAcquisition = {
  type?: TAcquisitionType;
  orderId?: number | null;
  stockOrderId?: number | null;
  stockOrderUuid?: string | null;
  productId?: number;
};

export type TValidationSerialLocation = {
  id?: number;
  place?: TLocationPlace;
  address?: string;
  countryName?: string | null;
  userId?: number;
  userName?: string;
};

export type TValidationSerialResponse = {
  isAvailable: boolean;
  acquisition?: TValidationSerialAcquisition;
  location?: TValidationSerialLocation;
};

